var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.833 79.9987V39.9987C125.833 25.2711 113.894 13.332 99.1659 13.332H26.1706C24.6978 13.332 23.5039 14.5259 23.5039 15.9987V26.9103C23.5039 28.8692 24.3655 30.7291 25.8599 31.9958L35.4766 44.6683C36.971 45.935 37.8326 47.7948 37.8326 49.7538V79.9987V143.027C37.8326 149.492 48.0682 142.972 49.8852 141.765C50.2875 141.497 50.8028 141.469 51.2324 141.689L57.8646 145.099C59.7775 146.081 62.0472 146.081 63.9602 145.099L70.6784 141.645C71.061 141.449 71.515 141.449 71.8975 141.645L78.6158 145.099C80.5287 146.081 82.7985 146.081 84.7114 145.099L91.4296 141.645C91.8122 141.449 92.2662 141.449 92.6487 141.645L99.367 145.099C101.28 146.081 103.55 146.081 105.462 145.099L112.107 141.684C112.53 141.465 113.037 141.491 113.437 141.748C115.244 142.909 125.833 149.645 125.833 143.116V79.9987Z",
    fill: "#FFBA33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 55.9987H37.832C38.1443 55.9987 37.832 28.4772 37.832 25.332C37.832 18.7046 32.4595 13.332 25.832 13.332C19.2046 13.332 13.832 18.7046 13.832 25.332V53.332C13.832 54.8048 15.0259 55.9987 16.4987 55.9987Z",
    fill: "#E99A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.834 81.3346C77.834 100.481 93.3548 116.001 112.501 116.001C131.647 116.001 147.167 100.481 147.167 81.3346C147.167 62.1888 131.647 46.668 112.501 46.668C93.3548 46.668 77.834 62.1888 77.834 81.3346Z",
    fill: "#FF7A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.5 80C108.5 82.9455 110.888 85.3333 113.833 85.3333H127.167C128.639 85.3333 129.833 84.1395 129.833 82.6667C129.833 81.1939 128.639 80 127.167 80H113.833V66.6667C113.833 65.1939 112.639 64 111.167 64C109.694 64 108.5 65.1939 108.5 66.6667V80Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHistory);
export default __webpack_public_path__ + "static/media/empty-history.6d66bbfe454db08bfc2a843fc18cb2c3.svg";
export { ForwardRef as ReactComponent };